import request from '@/utils/request'

// ==================== 题库管理相关接口 ====================

// 获取当前教师的题库列表
export function getMyQuestionBanks() {
  return request({
    url: '/question-bank/list',
    method: 'get'
  })
}

// 获取公开题库列表
export function getPublicQuestionBanks() {
  return request({
    url: '/question-bank/public',
    method: 'get'
  })
}

// 根据课程ID获取题库列表
export function getQuestionBanksByCourseId(courseId) {
  return request({
    url: `/question-bank/course/${courseId}`,
    method: 'get'
  })
}

// 创建题库
export function createQuestionBank(data) {
  return request({
    url: '/question-bank',
    method: 'post',
    data
  })
}

// 更新题库
export function updateQuestionBank(id, data) {
  return request({
    url: `/question-bank/${id}`,
    method: 'put',
    data
  })
}

// 删除题库
export function deleteQuestionBank(id) {
  return request({
    url: `/question-bank/${id}`,
    method: 'delete'
  })
}

// ==================== 题库文件夹管理相关接口 ====================

// 获取题库文件夹树形结构
export function getQuestionBankFolderTree(bankId) {
  return request({
    url: `/question-bank/${bankId}/folders`,
    method: 'get'
  })
}

// 创建文件夹
export function createQuestionBankFolder(bankId, data) {
  return request({
    url: `/question-bank/${bankId}/folders`,
    method: 'post',
    data
  })
}

// 更新文件夹
export function updateQuestionBankFolder(folderId, data) {
  return request({
    url: `/question-bank/folders/${folderId}`,
    method: 'put',
    data
  })
}

// 删除文件夹
export function deleteQuestionBankFolder(folderId) {
  return request({
    url: `/question-bank/folders/${folderId}`,
    method: 'delete'
  })
}

// 移动文件夹
export function moveQuestionBankFolder(folderId, newParentId) {
  return request({
    url: `/question-bank/folders/${folderId}/move`,
    method: 'put',
    params: { newParentId }
  })
}

// ==================== 题库题目管理相关接口 ====================

// 获取文件夹中的题目列表
export function getFolderQuestions(folderId) {
  return request({
    url: `/question-bank/folders/${folderId}/questions`,
    method: 'get'
  })
}

// 添加题目到文件夹
export function addQuestionToFolder(bankId, folderId, questionId) {
  return request({
    url: `/question-bank/${bankId}/folders/${folderId}/questions`,
    method: 'post',
    params: { questionId }
  })
}

// 从文件夹移除题目
export function removeQuestionFromFolder(bankId, questionId) {
  return request({
    url: `/question-bank/${bankId}/questions/${questionId}`,
    method: 'delete'
  })
}

// 移动题目到其他文件夹
export function moveQuestionToFolder(bankId, questionId, newFolderId) {
  return request({
    url: `/question-bank/${bankId}/questions/${questionId}/move`,
    method: 'put',
    params: { newFolderId }
  })
}

// 获取题库中的所有题目
export function getBankQuestions(bankId) {
  return request({
    url: `/question-bank/${bankId}/questions`,
    method: 'get'
  })
}

// 根据课程ID获取该课程所有题库中的题目
export function getCourseQuestions(courseId) {
  return request({
    url: `/question-bank/course/${courseId}/questions`,
    method: 'get'
  })
}

// 根据课程ID和搜索条件获取题目
export function searchCourseQuestions(courseId, filters = {}) {
  return request({
    url: `/question-bank/course/${courseId}/questions/search`,
    method: 'get',
    params: {
      questionType: filters.questionType || null,
      knowledge: filters.knowledge || null,
      difficulty: filters.difficulty || null
    }
  })
}
